var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 23.7734,
    y: 43.7808,
    width: 19.3,
    height: 32.2195
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_743_3217_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_743_3217)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5733 47.7808C38.8944 47.7808 39.1322 48.0791 39.0607 48.3922L34.6677 67.6116C34.6157 67.839 34.4135 68.0002 34.1802 68.0002L28.2737 68.0002C27.9525 68.0002 27.7147 67.7018 27.7862 67.3888L32.1792 48.1693C32.2312 47.942 32.4335 47.7808 32.6667 47.7808L38.5733 47.7808Z",
    fill: "url(#paint0_linear_743_3217)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 35.1218,
    y: 43.7808,
    width: 19.3,
    height: 32.2195
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_1_743_3217_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_743_3217)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6221 47.7808C39.3009 47.7808 39.0631 48.0791 39.1346 48.3922L43.5276 67.6116C43.5796 67.839 43.7818 68.0002 44.0151 68.0002L49.9217 68.0002C50.2428 68.0002 50.4806 67.7018 50.4091 67.3888L46.0161 48.1693C45.9641 47.942 45.7619 47.7808 45.5286 47.7808L39.6221 47.7808Z",
    fill: "url(#paint1_linear_743_3217)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_743_3217)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.5067,
    cy: 29.5068,
    r: 15.0576,
    transform: "rotate(-84.1811 38.5067 29.5068)",
    fill: "url(#paint2_linear_743_3217)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.461182,
    y: -0.548096,
    width: 79.3237,
    height: 62.1042
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_2_743_3217_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_743_3217)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8625 51.5562C73.8625 52.6607 72.9671 53.5562 71.8625 53.5562L6.5388 53.5561C5.43423 53.5561 4.5388 52.6607 4.5388 51.5561L4.5388 6.45182C4.5388 5.34725 5.43423 4.45182 6.5388 4.45182L71.8626 4.45183C72.9671 4.45183 73.8626 5.34726 73.8626 6.45183L73.8625 51.5562Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8625 51.5562C73.8625 52.6607 72.9671 53.5562 71.8625 53.5562L6.5388 53.5561C5.43423 53.5561 4.5388 52.6607 4.5388 51.5561L4.5388 6.45182C4.5388 5.34725 5.43423 4.45182 6.5388 4.45182L71.8626 4.45183C72.9671 4.45183 73.8626 5.34726 73.8626 6.45183L73.8625 51.5562Z",
    fill: "url(#paint3_linear_743_3217)",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8625 52.5562L6.53833 52.5561C5.98626 52.5559 5.53833 52.1083 5.53833 51.5561L5.53833 6.45165C5.53842 5.8996 5.98632 5.45191 6.53833 5.45165L71.8626 5.45166C72.4148 5.45166 72.8625 5.89945 72.8626 6.45166L72.8625 51.5562C72.8625 52.1084 72.4148 52.5562 71.8625 52.5562Z",
    stroke: "url(#paint4_linear_743_3217)",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_743_3217)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.5339,
    y: 24.6677,
    width: 5.77698,
    height: 17.3309,
    rx: 0.2,
    fill: "url(#paint5_linear_743_3217)",
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_743_3217)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.9773,
    y: 30.4539,
    width: 5.77698,
    height: 11.554,
    rx: 0.2,
    fill: "url(#paint6_linear_743_3217)",
    shapeRendering: "crispEdges"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_743_3217)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.085,
    y: 16.0044,
    width: 5.77698,
    height: 25.9964,
    rx: 0.2,
    fill: "url(#paint7_linear_743_3217)",
    shapeRendering: "crispEdges"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_di_743_3217)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.6416,
    y: 21.7798,
    width: 5.77698,
    height: 20.2194,
    rx: 0.2,
    fill: "url(#paint8_linear_743_3217)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_743_3217",
    x: 23.7734,
    y: 43.7808,
    width: 19.3,
    height: 32.2195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_743_3217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_743_3217",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_743_3217_clip_path",
    transform: "translate(-23.7734 -43.7808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5733 47.7808C38.8944 47.7808 39.1322 48.0791 39.0607 48.3922L34.6677 67.6116C34.6157 67.839 34.4135 68.0002 34.1802 68.0002L28.2737 68.0002C27.9525 68.0002 27.7147 67.7018 27.7862 67.3888L32.1792 48.1693C32.2312 47.942 32.4335 47.7808 32.6667 47.7808L38.5733 47.7808Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_743_3217",
    x: 35.1218,
    y: 43.7808,
    width: 19.3,
    height: 32.2195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_743_3217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_743_3217",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_743_3217_clip_path",
    transform: "translate(-35.1218 -43.7808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6221 47.7808C39.3009 47.7808 39.0631 48.0791 39.1346 48.3922L43.5276 67.6116C43.5796 67.839 43.7818 68.0002 44.0151 68.0002L49.9217 68.0002C50.2428 68.0002 50.4806 67.7018 50.4091 67.3888L46.0161 48.1693C45.9641 47.942 45.7619 47.7808 45.5286 47.7808L39.6221 47.7808Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_743_3217",
    x: 9.44775,
    y: 0.447998,
    width: 58.1177,
    height: 58.1177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_743_3217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_743_3217",
    x: -0.461182,
    y: -0.548096,
    width: 79.3237,
    height: 62.1042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_743_3217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_743_3217",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_743_3217_clip_path",
    transform: "translate(0.461182 0.548096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.8625 51.5562C73.8625 52.6607 72.9671 53.5562 71.8625 53.5562L6.5388 53.5561C5.43423 53.5561 4.5388 52.6607 4.5388 51.5561L4.5388 6.45182C4.5388 5.34725 5.43423 4.45182 6.5388 4.45182L71.8626 4.45183C72.9671 4.45183 73.8626 5.34726 73.8626 6.45183L73.8625 51.5562Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_743_3217",
    x: 29.0339,
    y: 24.1677,
    width: 8.7771,
    height: 21.8311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_743_3217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_743_3217",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_743_3217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_743_3217",
    x: 17.4773,
    y: 29.9539,
    width: 8.7771,
    height: 16.054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_743_3217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_743_3217",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_743_3217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_743_3217",
    x: 40.585,
    y: 15.5044,
    width: 8.7771,
    height: 30.4963,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_743_3217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_743_3217",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_743_3217"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_di_743_3217",
    x: 52.1416,
    y: 21.2798,
    width: 8.7771,
    height: 24.7195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_743_3217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_743_3217",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_743_3217"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3217",
    x1: 32.3754,
    y1: 50.3515,
    x2: 21.9352,
    y2: 60.6075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3217",
    x1: 45.8199,
    y1: 50.3515,
    x2: 56.2601,
    y2: 60.6075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3217",
    x1: 36.8156,
    y1: 29.604,
    x2: 46.875,
    y2: 40.2021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba6be7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_3217",
    x1: 73.8625,
    y1: 53.5562,
    x2: -3.16545,
    y2: 25.9437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_743_3217",
    x1: 11.4712,
    y1: -0.458606,
    x2: 50.8634,
    y2: 65.9676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_743_3217",
    x1: 29.6674,
    y1: 43.7318,
    x2: 41.2153,
    y2: 40.0498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_743_3217",
    x1: 18.1107,
    y1: 43.1632,
    x2: 28.4644,
    y2: 38.2115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_743_3217",
    x1: 41.2184,
    y1: 44.6004,
    x2: 53.3904,
    y2: 42.0132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_743_3217",
    x1: 52.7751,
    y1: 44.0212,
    x2: 64.6128,
    y2: 40.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon03);
export default __webpack_public_path__ + "static/media/service-icon03.86507af7b9a580af135d316c1e6892aa.svg";
export { ForwardRef as ReactComponent };